import { getTotalKeywordsName } from "../../../consts";
import type { SiteVisitsOvertime } from "../hooks/useVisitsOvertimeData";
import type { ProcessedData } from "../types";

interface LegendSource {
    name: string;
    visits: number;
}

export const buildLegendSources = (
    total: Record<string, { Visits: number; Share: number }> = {},
    monthlyBreakdown: Record<string, Record<string, { Visits: number }>> = {},
    siteVisits: Record<string, number>,
): LegendSource[] => {
    const sources = Object.entries(total)
        .map(([name]) => {
            const monthlyVisits = Object.values(monthlyBreakdown).map((month) => month[name]?.Visits || 0);
            const monthlyAverage =
                monthlyVisits.length > 0
                    ? monthlyVisits.reduce((sum, visits) => sum + visits, 0) / monthlyVisits.length
                    : 0;

            return {
                name,
                visits: monthlyAverage,
            };
        })
        .filter(({ visits }) => visits > 0);

    const totalVisits = Object.values(siteVisits).reduce((sum, value) => sum + value, 0);
    const totalMonthlyAverage = totalVisits / Object.keys(monthlyBreakdown).length;

    sources.push({ name: getTotalKeywordsName(), visits: totalMonthlyAverage });

    return sources;
};

export const processSingleModeData = (data: Record<string, SiteVisitsOvertime>) => {
    if (!data) {
        return { processedData: null, availableLobs: [], lobVisitsData: {} };
    }
    const domains = Object.keys(data);
    const firstDomain = domains[0];
    if (!firstDomain) {
        return { processedData: null, availableLobs: [], lobVisitsData: {} };
    }

    const siteData = data[firstDomain];
    const lobVisitsData = siteData?.SiteVisits
        ? Object.fromEntries(
              Object.entries(siteData.SiteVisits).map(([lobName, lobData]: [string, any]) => [
                  lobName,
                  lobData.Visits || 0,
              ]),
          )
        : {};

    const processedData: ProcessedData = {
        total: siteData?.TotalLobsVisits || {},
        breakdown: siteData?.LobsMonthlyBreakDown || {},
        siteVisits: siteData?.SiteVisits || {},
    };

    return {
        processedData,
        availableLobs: siteData?.TotalLobsVisits ? Object.keys(siteData.TotalLobsVisits) : [],
        lobVisitsData,
    };
};
